"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _icons = require("@ori-ui/icons");
var _react = require("react");
var _hooks = require("../../hooks");
var _Loading = require("../Loading");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const FeedbackBenefitBanner = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "FeedbackBenefitDialog_FeedbackBenefitBanner" */'../FeedbackBenefitBanner')))).FeedbackBenefitBanner
}));

/**
 * Content of FeedbackBenefitDialog.
 */
const Content = () => {
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    data,
    loading,
    link
  } = (0, _hooks.useData)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}),
    children: [loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}) : null, data && !loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(FeedbackBenefitBanner, {
      link: link,
      data: data
    }) : null, !data && !loading ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ErrorWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircle, {
        fontSize: "large"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Error, {
        children: translations.dataLoadingError
      })]
    }) : null]
  });
};
exports.Content = Content;
